@if (variant === 'tab') {
  <!-- MOBILE.1 R2. The Ask Via item in the phone bottom bar: flat, the same
       size as its neighbours, Jackson's call on the gate. -->
  <button type="button" (click)="toggleChat()" class="via-tab">
    <img src="/assets/images/chat-gpt/ask-via.svg" alt="" class="via-tab__ic" />
    <span class="via-tab__label">Ask Via</span>
  </button>
} @else {
  <!-- Named for what it does. It was named by its image, "Via Logo". -->
  <button
    type="button"
    (click)="toggleChat()"
    mat-icon-button
    class="ask-via"
    aria-label="Ask Via"
  >
    <img src="/assets/images/chat-gpt/ask-via.svg" alt="" />
  </button>
}

<ng-template #chatAccessTooltip>
  <div class="custom-tooltip large green intro-via">
    <mat-icon svgIcon="chat-via"></mat-icon>
    <h3>Unlock Via with an account</h3>
    <p>Get personalized career and education guidance by chatting with Via</p>
  </div>
</ng-template>
